import { h } from 'preact'
import { useSelector } from 'react-redux'
import translate from '@core/translate'

export default function NumberOfHits() {
	const { pagingFilteringContext } = useSelector(state => state.currentPage)
	const { totalItems } = pagingFilteringContext ?? {}

	const text = translate('search.numberOfResults', totalItems)

	return (
		<div className="total-hits-wrapper">
			<span>{text}</span>
		</div>
	)
}
